<template>
  <div >
      <div class="customHeight">
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <md-dialog-title class="heading">Ticket Management</md-dialog-title>
    
      <md-dialog-content>
      <bol-photo-Zoom-form ref="BolPhotoZoomForm" 
         :on-data-refresh="updatePhoto" 
         :onScan="loadWT"
         title="WT Photos (Zoom)"
      />
        <form novalidate @submit.prevent="doSaveUser">
          <div class="SpinnerAdj">
            <callingApiCenter
              type="bar"
              :paths="[
                '/api/w/DOs/WebSearchBooking',
                '/api/w/users',
                '/api/w/DOs/WebAssignBooking',
              ]"
            >
            </callingApiCenter>
          </div>

          <div v-if="getSearchBox == true">
            <div class="savemenu">
              <md-button class="md-raised custButton" @click="cancalAction"
              ><span class="icons-center material-icons">cancel</span
              >Back</md-button
                 >
                 <md-button
                   type="submit"
                   class="md-raised custButton"
                 >
                 <span class="icons-center material-icons">create</span
                  >Assign</md-button
                >
            </div>
            <div class="inputBoxDouble">
              <div class="inputBoxWide">
                <md-field :class="getValidationClass('dataForm.bales')">
                  <label>Bale Count</label>
                  <md-input v-model="dataForm.bales" />
                </md-field>
              </div>
            </div>

            <div ref = "refUpgradeSuggestion" class="inputBoxDouble">
              <div class="inputBoxWide">
                <md-field>
                 
                   <auto-complete-master-data-select :class="getValidationClass('dataForm.upgradeSuggestion')"
                                                :prepared-options="filterSuggestion(this.getMasterDataAsSelectOptionByGroup('UPGRADE_MASTER'), matnr)"
                                                label="Upgrade Suggestion "
                                                :init-value="dataForm.upgradeSuggestion"
                                                :on-item-changed="handleUpgradeSuggestionChanged"
                                                 
                                                >
            </auto-complete-master-data-select>
                </md-field>
              </div>
            </div>

            <div class="inputBoxDouble">
              <div class="inputBoxWide">
                <md-field :class="getValidationClass('dataForm.upgradeBales')">
                  <label>Upgrade bales</label>
                  <md-input v-model="dataForm.upgradeBales" />
                </md-field>
              </div>
            </div>

            <div class="inputBoxDouble">
              <div class="inputBoxWide">
                <md-field :class="getValidationClass('dataForm.scanWt')">
                  <label>Weight Ticket</label>
                  <md-input v-model="dataForm.scanWt" />
                </md-field>
              </div>
            </div>

            
            <div class= "inputBoxMessage">
              <b-notification class = "notifySize"
                  type="is-danger"
                  v-model="notifyActive"
                  aria-close-label="Close notification">
                  {{notifyMessage}}
              </b-notification>

            </div>


            <div class="inputBoxDouble">
              <div class="inputBtnSpace">
                <md-button
                  class="md-raised custButtonWide"
                  @click="searchBooking(dataForm)"
                  ><span class="icons-center material-icons">cancel</span
                  >Scan Ticket</md-button
                >
              </div>

              <div class="inputBtnSpace">
                <md-button
                  class="md-raised custButtonWide"
                  :disabled="!hasPhoto"
                  @click="toggleItemPhoto"
                  ><span class="icons-center material-icons">cancel</span
                  >View Scan Ticket</md-button
                >
              </div>

              <div class="inputBtnSpace">
                <md-button
                  class="md-raised custButtonWide"
                  @click="clearAction"
                  ><span class="icons-center material-icons">cancel</span
                  >Clear</md-button
                >
              </div>
            </div>
          </div>
<!--
          <div v-if="getBookingTable"
            class = "fixBlur"
          >

            <h1>PUT SCALE TICKET # LOGICAL HERE, AND BACK TO LAST PAGE AFTER DONE THE SCAN</h1>
          </div>
-->
        <div v-if="getBookingTable" class="fixBlur"  style="height:1200px; width: 750px; overflow: hidden;">
          <div class="alwaysShow">
            <div>
              <md-dialog-actions>
                <div style="margin-top:50px;">
                  <!--
                  <md-button class="md-raised custButton" 
                    @click="cancalAction"
                    :disabled="hasError"
                    ><span class="icons-center material-icons">cancel</span
                  >Back</md-button
                 >
                 -->
                  <md-button class="md-raised custButton" 
                    @click="doCancelAction"
                    ><span class="icons-center material-icons">cancel</span
                  >Cancel</md-button
                 >
                 <!--
                 <md-button
                   type="submit"
                   class="md-raised custButton"
                 >
                 <span class="icons-center material-icons">create</span
                  >Assign</md-button
                >
                -->
                <!-- add webcam here -->
                <div class="errMsg" v-if="showErr"><label id="err"></label></div>

                <div style="margin-top:20px;">
                   <md-field style="width:300px">
                     <label>Weight Ticket Number</label>
                     <md-input v-model="dataForm.scanWt"></md-input>
                     </md-field>
                </div> 
                <hr id="pb1"/>

                
                <md-progress-bar  id="pb" style="display:none" md-mode="indeterminate"/>  
            <div v-if="isCameraOpen && !isLoading" class="camera-shoot">
            <md-button class="md-fab md-primary" @click.prevent="takePhoto" v-if="!isPhotoMode">
               <md-tooltip>Take photo and Get BOL</md-tooltip>
               <md-icon>photo_camera</md-icon>
            </md-button>   
          </div>
          <div v-if="isCameraOpen && !isLoading" class="camera-shoot" style="margin-top:10px;">
            <md-button v-if="isPhotoMode" class="md-fab md-primary" @click.prevent="refreshCamera">
               <md-tooltip>Back to video mode</md-tooltip>
               <md-icon>slideshow</md-icon>
            </md-button>   
          </div>
          <div v-if="isCameraOpen && !isLoading" class="camera-shoot" style="margin-top:10px;">
            <md-button :disabled="!this.isMultiCam" class="md-fab md-primary" @click.prevent="switchCam">
               <md-tooltip>Switch Camera</md-tooltip>
               <md-icon>flip</md-icon>
            </md-button>   
          </div>
          <div v-if="isCameraOpen && !isLoading" class="camera-shoot" style="margin-top:10px;">
            <md-button :disabled="!this.hasFlashLight" class="md-fab md-primary" @click.prevent="flashLightOnOff">
              <md-tooltip>Turn flash light on off</md-tooltip>
              <md-icon>flash_on</md-icon>
            </md-button>   
          </div> 
          <div v-if="isCameraOpen && !isLoading" class="camera-shoot" style="margin-top:10px;">
            <md-button :disabled="!isPhotoTaken" class="md-fab md-primary" @click.prevent="saveImage">
              <md-tooltip>save photo</md-tooltip>
              <md-icon>file_upload</md-icon>
            </md-button>   
          </div>

          <video v-show="!isPhotoTaken && !isScanImg" ref="camera" autoplay loop muted height="480" width="640" style="margin-top:-250px;"></video>
          <canvas v-show="isPhotoTaken && !isScanImg" id="photoTaken" ref="canvas" height="480" width="640" style="margin-top:-250px;"></canvas>
          <img v-if="isScanImg" id="testImg" height="480" width="640" style="margin-top: -250px;">

          <div v-if="hasZoom">
             <input type="range" id="zoom" name="zoom">
          </div>   
          
          
          
              <!-- end webcam component -->
          </div>
              </md-dialog-actions>
            </div>
          </div>
          </div> 
        </form>
      </md-dialog-content>
    </md-dialog>
     </div>
  </div>
</template>

<style scoped>
form {
  min-width: 640px;
  max-width: 1200px;
  margin: 24px;
}

.tableFormat {
  height: 400px;
}

.tableMinFormat {
  height: 100px;
}

form .md-field {
  margin: 0 0;
}

.md-dialog {
    max-height: 90% !important;
}

.inputBoxSpace {
  border: 1px solid #cacbcc;
  border-radius: 5px;
  color: #29303b;
  font-size: 18px;
  height: auto;
  width: 200px;
  line-height: 1em;
  padding: 5px 5px 5px 5px;
  margin-top: 6px;
}

.inputBoxWide {
  border: 1px solid #cacbcc;
  border-radius: 5px;
  color: #29303b;
  font-size: 18px;
  height: auto;
  width: 425px;
  line-height: 1em;
  padding: 5px 5px 5px 5px;
  margin-top: 6px;
}

.inputBtnSpace {
  font-size: 18px;
  height: auto;
  line-height: 1em;
  padding: 5px 5px 5px 5px;
  margin-top: 6px;
}

.inputBoxDouble {
  width: 450px;
  justify-content: space-around;
  display: flex;
  flex-direction: row;
  margin: auto;
}

.inputBoxMessage {
  width: 425px;
  margin: auto;
}



.inputBoxInbound {
  border: 1px solid #cacbcc;
  border-radius: 5px;
  color: #29303b;
  font-size: 12px;
  height: auto;
  line-height: 1em;
  padding: 5px 5px 5px 5px;
  margin-top: 6px;
}

.inputBoxInbound:hover {
  border: 2px solid #448aff;
  border-radius: 5px;
  color: #29303b;
  font-size: 12px;
  height: auto;
  line-height: 1em;
  padding: 5px 5px 5px 5px;
  margin-top: 6px;
  background-color: #e0eff7;
}

.alwaysShow {
  position: fixed;
  right: 60px;
  top: 30px;
}

.ErrorMessage {
  color: #f14668 !important;
}

.redButton {
  background-color: #c50000;
  z-index: 4;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

.icons-center {
  vertical-align: middle;
  margin-right: 10px;
}

.custButton {
  margin: 10px;
  width: 120px;
  height: 40px;
  line-height: 40px;
  font-size: 0.9rem;
}

.custButtonWide {
  width: 200px;
  height: 40px;
  line-height: 40px;
  font-size: 0.9rem;
}

.SpinnerAdj {
  margin-left: 90px;
}

.heading {
  padding-top: 20px;
  margin-bottom: 0;
  color: #555555;
  width: 92%;
  line-height: 3;
  font-size: 30px;
  font-family: Roboto Slab;
  margin-left: 44px;
}

.layout {
  padding-top: 7px;
  padding-bottom: 7px;
  width: 92%;
  line-height: 1.5;
  color: #555555;

  font-family: Roboto Slab;
  margin: auto;
}

.md-table-row {
  background: white;
}

.md-table.md-theme-default .md-table-row.md-selected-single {
  background: #726a95;
}

.camera-shoot {
   margin-left: 650px;
   /*margin-top: -200px;*/
}

hr {
   width: 100%;
   height: 5px;
   border: 0 none;
   margin-right: auto;
   margin-left: auto;
   margin-top: 10px;
   margin-bottom: 10px;
   background-color:#555;
}

#pb {
   margin-left: auto;
   margin-right: auto;
   margin-top: 10px;
   margin-bottom: 10px;

}

.savemenu {
   /*border: 3px solid #73AD21;*/
   /*margin-top: -70px;*/
   margin-left: 350px;
   margin-bottom: 30px;
}

.errMsg {
   position: absolute;
   padding: 5px 5px 5px 5px;
   width: 100;
   height: 50;
   /*border: 2px solid #29303b;*/
   margin-top:-30px;
   margin-left: 250px;
   color: red;
}

</style>
<script>
import { validationMixin } from "vuelidate";
import { mapGetters } from "vuex";
import dateFormat from "../utils/dateFormat";
import { minLength, required, maxLength,integer } from "vuelidate/lib/validators";
import AutocompleteCcicLocationSelect from "./AutocompleteCcicLocationSelect.vue";
import DatePickerBackdate from "./DatePickerBackDate.vue";
import callingApiCenter from "../components/CallingApiCenter.vue";
//import api from "../api";
import { newAPIPost } from '../api/index.js';
import load from "../vuex/load";
import moment from 'moment';
import BolPhotoZoomForm from "../components/BolPhotoZoomForm.vue";


const getInitialdataForm = () => ({
  bales: null,
  upgradeSuggestion: null,
  upgradeBales: null,
  scanWt: null,
});

const SUPPORT_MEDIA_DEVICES = 'mediaDevices' in navigator;

const savePhotoReq = () => ({
     parentSeqNo: null,
     parentLoadKey: null,
     user: null,
     photoType: null,
     parentType: null,
     photoKey: null,
     refTimeStamp: null,
     image: {
       fileName: null,
       folder: null,
       imageBase64: null,
     },
});

const photoItem = () => ({
     apptNo: null,
     inboundShipment: null,
});

const photoMetaLoading = [
    {
      display: "WT SCAN",
      key: "BWT",
      fileName: "-wtScan.jpg",
    },
    //{
    //  display: "BOL Capture",
    //  key: "BWT1",
    //  fileName: "-BolPic.jpg",
    //},
  ];


export default {
  components: { AutocompleteCcicLocationSelect, callingApiCenter,DatePickerBackdate, BolPhotoZoomForm },
  mixins: [validationMixin],
  props: {
    mode: String,
    action: Function,
  },
  data: () => ({
    showDialog: false,
    dataForm: getInitialdataForm(),
    savePhotoInfo: savePhotoReq(), 
    photoItem: photoItem(),   
    items: [],
    selected: null,
    getBookingTable: false,
    getSearchBox: true,
    lenError: null,
    loads: [],
    notifyActive: false,
    notifyMessage: 'Test!',
    matnr: "",
    isCameraOpen: false,
    isLoading: false,
    isPhotoMode: false,
    isMultiCam: false,
    hasFlashLight: false,
    isPhotoTaken: false,
    isScanImg: false,
    hasZoom: false,
    isShotPhoto: false,
    img: null,
    cameras: [],
    camera: null,
    current_cam: null,
    link: '#',
    camnum: null,
    selectedItem: [],
    photoType: null,
    photos: [],
    //urlToSave: null,
    getPhotoRequest: null,
    selectedItem: [],
    hasPhoto: true,
    hasError: false,
    showErr: false,
    orgwt: null,
    recWindow: null,
  }),
  computed: {
    ...mapGetters([
      "getMasterDataByGroup",
      "getMasterDataName",
      "getUserProfile",
      "getMasterDataAsSelectOptionByGroup",
    ]),
  },

  validations: {
    dataForm: {
      bales: {required},
      upgradeSuggestion: {required},
      upgradeBales: {required},
      scanWt:{},

    },
  },

  methods: {

    filterSuggestion : (value, matnr) => value.filter(it => it.grade == matnr),

    handleUpgradeSuggestionChanged(id,a,b,c,d,e,f) {
      this.dataForm.upgradeSuggestion = f;
    },


    async openDialog(loads) {
      //var url = "https://named-account-web-dev.s3.us-west-2.amazonaws.com/upload_images/INBOUND/"
      console.log("rec window: " + loads.receivingWindows);
      var url = this.getPicURL();
      this.$store.commit("clearApiError");
      this.$v.dataForm.$reset();
      this.dataForm = getInitialdataForm();
      this.loads = loads;
      this.matnr = this.loads.matnr;
      this.dataForm.bales = this.loads.bales;
      this.dataForm.upgradeSuggestion = this.loads.upgradeSuggestion;
      this.dataForm.upgradeBales = this.loads.upgradeBales;
      this.dataForm.scanWt = this.loads.scanWt;
      this.orgwt = this.dataForm.scanWt;
      this.getBookingTable = false;
      this.getSearchBox = true;
      this.notifyActive = false;
      this.hasError = true;
      this.showErr = true;
      this.photoType = "";
      this.selectedItem = loads;
      this.recWindow = loads.receivingWindows; 
      url = url + this.selectedItem.apptNo + "/-wtScan.jpg";
      this.urlExists(url);
      //console.log("hasPhoto: " + this.hasPhoto);
      this.photoItem.apptNo = this.selectedItem.apptNo;
      this.photoItem.inboundShipment = this.selectedItem.inboundShipment;
      console.log("load: " + JSON.stringify(loads));
      this.showDialog = true;
    },

    async searchBooking(item) {
      this.notifyActive = false;
      const request = JSON.parse(JSON.stringify(item));
      this.getBookingTable = true;
      this.getSearchBox = false;
      console.log("open Cam");
      console.log("isPhotoMode: " + this.isPhotoMode);
      // if (requestdata != null && requestdata.length > 0) {
      //    console.log("webcam::inboundShipment: " + requestdata[0].inboundShipment);
      //    console.log("webcam::bol: " + requestdata[0].bol);
      //    this.selectedItem = requestdata;
      //    this.photoType = parentPhotoType;
      // }
      
      await this.detectCam();

    },


    clearAction() {
      this.dataForm.bales = null;
      this.dataForm.upgradeSuggestion = null;
      this.dataForm.upgradeBales = null;
      this.dataForm.scanWt = null;
      this.$refs.refUpgradeSuggestion.querySelector('button.md-clear').click();
      
    },

    getValidationClass(fieldName) {
      const field = _(this.$v).lookup(fieldName);

      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty,
        };
      }
      return {};
    },


    getTableHeight() {
       
       if (this.items.length === 0)
       {
          return {
          "tableMinFormat": true,
        };
       }
       else
       {
         return {
          "tableFormat": true,
        };
       }
        return {};
      },

   

    cancalAction() {
      this.lenError = null;
      if (this.getBookingTable == true) {
        this.$store.commit("clearApiError");
        this.getBookingTable = false;
        this.getSearchBox = true;
        console.log("load scaleTicket: " + this.selectedItem.scanWt);
        console.log("scale ticket: " + this.dataForm.scanWt);
        this.selectedItem.scanWt = this.dataForm.scanWt;
        this.isCameraOpen = false;
        this.isPhotoTaken = false;
        this.isShotPhoto = false;
        //this.dataForm.scanWt = "";
        this.stopCameraStream(); 
      } else {
        this.$store.commit("clearApiError");
        console.log("close app");
        this.showDialog = false;
      }
    },

    doCancelAction() {
      this.lenError = null;
      if (this.getBookingTable == true) {
        this.$store.commit("clearApiError");
        this.getBookingTable = false;
        this.getSearchBox = true;
        this.isCameraOpen = false;
        this.isPhotoTaken = false;
        this.isShotPhoto = false;
        this.dataForm.scanWt = this.orgwt;
        //this.dataForm.scanWt = "";
        this.stopCameraStream(); 
      } else {
        this.$store.commit("clearApiError");
        console.log("close app");
        this.showDialog = false;
      }
      
    },

    async doSaveUser() {
      this.$v.dataForm.$touch();
      console.log(`doSaveUser , invalid=${this.$v.dataForm.$invalid}`);
      if (this.$v.dataForm.$invalid) {
        //  this.$refs.top.$el.focus();
          return;
        }
      var error = null;
      this.notifyMessage = "";
      //alert(Number(this.dataForm.bales));
      //alert(Number.isInteger(Number(this.dataForm.bales)));
      //if (Number.isInteger(Number(this.dataForm.bales)) == false || this.dataForm.bales.includes('.') || Number(this.dataForm.bales) < 1)
      this.dataForm.bales = this.dataForm.bales.trim();
      console.log(`bales: ${this.dataForm.bales}`);
      if (this.dataForm.bales.indexOf('.') >= 0 || Number.isInteger(Number(this.dataForm.bales)) === false || Number(this.dataForm.bales) < 1)
      {
          error = "Bales count must be a positive whole number!"
      }
      //alert(this.dataForm.bales.length + " error: " + error);
      // if (Number(this.dataForm.bales) >= 100)
      // {
      //     if (error == null) {
      //       error = "Bales count must be in or less than 2 digits number!"
      //     } else {
      //       error += "; Bales count must be in or less than 2 digits number!";
      //     }
      // }
      var p_bales = Number(this.dataForm.bales);
      if (p_bales < 1 || p_bales > 99)
      {
        if (error == null) {
            error = "Bales count must be in between 1 and 99!"
          } else {
            error += "; Bales count must be in between 1 and 99!";
          }
      }

      //if (!Number.isInteger(Number(this.dataForm.upgradeBales)) || this.dataForm.upgradeBales.includes('.')||this.dataForm.upgradeBales< '1')
      if (this.dataForm.upgradeBales.indexOf('.') >= 0 || Number.isInteger(Number(this.dataForm.upgradeBales)) == false || Number(this.dataForm.upgradeBales) < 1)
      {
        if (error == null){
          error = "Upgrade Bales must be a positive whole number!"
        }
        else
        {
          error += "; Upgrade Bales must be a positive whole number!"
        }

      }
      this.dataForm.upgradeBales = this.dataForm.upgradeBales.trim();
      console.log(`upgrade bales: ${this.dataForm.upgradeBales}`);
      var p_upgradebales = Number(this.dataForm.upgradeBales);
      if (p_upgradebales < 1 || p_upgradebales > 99)
      {
        if (error == null) {
            error = "Upgrade bales count must be in between 1 and 99!"
          } else {
            error += "; Upgrade bales count must be in between 1 and 99!";
          }
      }

      // if (Number(this.dataForm.upgradeBales) >= 100)
      // {
      //   if (error == null){
      //     error = "Upgrade Bales must be in or less than 2 digits number!"
      //   }
      //   else
      //   {
      //     error = error + "; Upgrade Bales must be in or less than 2 digits number!"
      //   }

      // }


      if (error == null)
      {
          this.showDialog = false;
          this.loads.bales = this.dataForm.bales;
          this.loads.upgradeSuggestion = this.dataForm.upgradeSuggestion;
          this.loads.upgradeBales = this.dataForm.upgradeBales;
          this.loads.scanWt = this.dataForm.scanWt;
          this.action(this.dataForm.bales, this.dataForm.upgradeSuggestion, this.dataForm.upgradeBales, this.dataForm.scanWt);  
      }
      else
      {
          this.notifyMessage = error;
          this.notifyActive = true;
          
       }
    //   this.showDialog = false;
    
      
           
    },

    async loadWT(scanWt)
    {
       console.log("ticketManagement wt: " + scanWt);
       this.dataForm.scanWt = scanWt;
    },

    toggleCamera() {
      if (this.isCameraOpen) {
          this.isCameraOpen = false;
          this.isPhotoTaken = false;
          this.isShotPhoto = false;
          this.isPhotoMode = true;
          this.isScanImg = false;
          this.isSaveScan = false;
          this.isCancelScan = false;
          this.stopCameraStream(); 
      } else {
          this.isCameraOpen = true;
          this.isPhotoMode = false;
          this.isScanImg = false;
          this.isSaveScan = false;
          this.isCancelScan = false;
          
          console.log("toggleCam::cameras length: " + this.cameras.length);
          this.camera = this.cameras[this.cameras.length -1];
          console.log("toggleCamera::camera deviceId: " + this.camera.deviceId);
          const devId = this.camera.deviceId;
          this.current_cam = devId;
          this.createCameraElement(devId);
      }
    },

    detectCam() {
      console.log("detect cam"); 
      if (SUPPORT_MEDIA_DEVICES) {
          this.mdevices = navigator.mediaDevices.enumerateDevices().then(devices => {
             this.cameras = devices.filter((device) => device.kind === 'videoinput');
             if (this.cameras.length === 0) {
                throw 'No camera found on this device';
             }
             console.log("cameras length: " + this.cameras.length);
             console.log("deviceId: " + this.cameras[0].deviceId);
             if (this.cameras.length === 1) {this.isMultiCam = false; console.log("device has 1 Cam")}
             else {this.isMultiCam = true; console.log("device has multi Cam")}
 
             this.cameras.forEach(
               (it) => {
                  console.log("device id: " + it.deviceId);
               }
             )
             this.toggleCamera();
          })
      }
    },

    refreshCamera() {
      this.setError("");
      this.isPhotoTaken = false;
      this.dataForm.scanWt = "";
      this.isPhotoMode = false;
      this.isScanImg = false;
      this.isSaveScan = false;
      this.pauseScan = false;
    },

    createCameraElement(camId) {
      this.isloading = true;
        
      if (SUPPORT_MEDIA_DEVICES) {

         navigator.mediaDevices.getUserMedia({
         video: {
           deviceId: camId,
           facingMode: ['user', 'enviornment'],
           width: { ideal: 1280 },
           height: { ideal: 1024 }
         }
         }).then(stream => {
            this.isLoading = false;
            this.$refs.camera.srcObject = stream;
            console.log("start stream");
            console.log(navigator.mediaDevices.getSupportedConstraints());
            const track = stream.getVideoTracks()[0];
            const capabilities = track.getCapabilities();
            console.log(track.getCapabilities());
            const settings = track.getSettings();
            console.log(track.getSettings());
            console.log("setting: " + settings.facingMode);
            console.log("setting: " + settings.zoom);
            if ('zoom' in settings)
            {
               this.hasZoom = true;
               console.log("zoom start");
               console.log("zoom min: " + capabilities.zoom.min);
               input.min = capabilities.zoom.min;
               console.log("zoom min: " + capabilities.zoom.max);
               input.max = capabilities.zoom.max;
               console.log("zoom min: " + capabilities.zoom.step);
               input.step = capabilities.zoom.step;
               input.value = settings.zoom;
               input.oninput = function(event) {
                 track.applyConstraints({advanced: [ {zoom: event.target.value} ]});
               }
            }
            else
            {
              this.hasZoom = false;
            }
          }
          ) 
      }

    },

    stopCameraStream() {
      if (this.$refs.camera && this.$refs.camera.srcObject)
      {
         let tracks = this.$refs.camera.srcObject.getTracks();
         console.log("number of tracks: " + tracks.length);
         tracks.forEach(
         track => {
           track.stop();
           console.log("track stopped");
         }
         )
      }
    },

    takePhoto() {
      if (!this.isPhotoTaken) {
          this.isShotPhoto = true;
          const FLASH_TIMEOUT = 50;
          setTimeout( () => {
            this.isShotPhoto = false;
          }, FLASH_TIMEOUT);
      }
      this.isPhotoTaken = !this.isPhotoTaken;
      this.pauseScan = true;
      console.log("after take photo isPhotoTaken: " + this.isPhotoTaken);
      const context = this.$refs.canvas.getContext('2d');
      //context.drawImage(this.$refs.camera, 0, 0, 1280, 1024);
      //context.drawImage(this.$refs.camera, 0, 0, 480, 640);
      context.drawImage(this.$refs.camera, 0.5, 0.5, 640, 480);
      //context.drawImage(this.$refs.camera, 0, 0, 445, 600);
      //context.drawImage(this.$refs.camera, 0, 0);
      context.font = "24px Comic Sans MS";
      context.fillStyle = "white";
      context.textAlign = "center";
      var current = new Date();
      console.log("current date: " + current);
      var photo_refTimeStamp = (current.getMonth() + 1) + "/" + current.getDate() + "/" + current.getFullYear();

      context.fillText(photo_refTimeStamp, this.$refs.canvas.width - 100, this.$refs.canvas.height - 30);
      console.log("host: " + location.host);
      this.isPhotoMode = true;

      //start text detection
      if (document.getElementById("pb"))
      {
        document.getElementById("pb").style.display = "";
      }
      if (document.getElementById("pb1"))
      {
        document.getElementById("pb1").style.display = "none";
      }
      const canvas = document.getElementById("photoTaken").toDataURL("image/jpeg")
          .replace("image/jpeg", "image/octet-stream");
      console.log("img: " + canvas);  
      var img = canvas.replace("data:image/octet-stream;base64,","");
      console.log("base64 img: " + img);  
      //const bol = api.post('/api/w/photo/WTDetection', {imageBase64: img, recWindow: this.recWindow})
      const bol = newAPIPost('/api/w/photo/WTDetection', {imageBase64: img, recWindow: this.recWindow})
            .then((it) => {
         this.$store.commit('clearApiError');
         console.log("internal var it length: " + it.length);
         console.log("internal var it: " + it);
         if (it.length > 15)
         {
            this.dataForm.scanWt = it.toString().substr(1,15)
         }
         else 
         {
            this.dataForm.scanWt = it;
         }
         console.log("selectedItem length: " + this.selectedItem.length);
         if (document.getElementById("pb"))
         {
            document.getElementById("pb").style.display = "none";
         }
         if (document.getElementById("pb1"))
         {
            document.getElementById("pb1").style.display = "";
         }
        //  const wtprefix = /^LN/g;
        //  console.log("wt number: " + this.dataForm.scanWt.match(wtprefix));
        //  const found = this.dataForm.scanWt.match(wtprefix);
        //  if (found != "LN")
        //  {
        //     //alert("Please check the scaned Weight number. It is not in the right format!");
        //     //if (document.getElementById("err"))
        //     //{
        //     //   document.getElementById("err").textContent = "Please check the scaned Weight number. It is not in the right format!"
        //     //   this.hasError = true;
        //     //   this.showErr = true;
        //     //}
        //     this.setError("Please check the scaned Weight number. It is not in the right format!");
        //  }
        if (this.dataForm.scanWt != null && this.dataForm.scanWt != "")
         {
            console.log("wt number prefix: " + this.dataForm.scanWt.substr(0,2))
            if (this.dataForm.scanWt.substr(0,2) != "LN")
            {
              if (this.dataForm.scanWt.substr(0,2) != "WN")
              {
                 this.setError("Please check the scaned Weight number. It is not in the right format!");
              }   
            }
         }
         else 
         {
            this.setError("Please check the scaned Weight number. It is not in the right format!");
         }

      })
    },

    switchCam() {
       this.stopCameraStream();
       console.log("before current cam id: " + this.current_cam);
       console.log("switchCam::cameras length: " + this.cameras.length);
       for (var i = 0; i < this.cameras.length; ++i)
       {
          console.log("device Id: " + this.cameras[i].deviceId);
          if (this.current_cam != this.cameras[i].deviceId) {
              this.current_cam = this.cameras[i].deviceId;
              break;
          }
       }
            
       console.log("after current cam id: " + this.current_cam);
       this.createCameraElement(this.current_cam);

    },

    flashLightOnOff() {

    },

    saveImage: function() {
                //console.log("downloadImage: selectedItem length: " + this.selectedItem.length);
                this.setError("");
                if (this.selectedItem != null) {
                   if (document.getElementById("pb"))
                   {
                       document.getElementById("pb").style.display = "";
                   }
                   if (document.getElementById("pb1"))
                   {
                       document.getElementById("pb1").style.display = "none";
                   }


                   console.log("selectItem inboundShipment: " + this.selectedItem.inboundShipment);
                   console.log("selectedItem parentSeqNo: " + this.selectedItem.apptNo);
                   console.log("selectedItem parentSeqNo: " + this.selectedItem.seqNo);
                   //process to upload image
                   this.savePhotoInfo.parentSeqNo = this.selectedItem.apptNo;
                   this.savePhotoInfo.parentLoadKey = this.selectedItem.seqNo;
                   this.savePhotoInfo.user = "INBOUND";
                   this.savePhotoInfo.photoType = "BWT";
                   this.savePhotoInfo.parentType = "BWT";
                   this.savePhotoInfo.photoKey = "BWT";
                   var current = new Date();
                   console.log("current date: " + current);
                   this.savePhotoInfo.refTimeStamp = (current.getMonth() + 1) + "/" + current.getDate() + "/" + current.getFullYear();
                   console.log("current date: " + this.savePhotoInfo.refTimeStamp);
                   this.savePhotoInfo.image.folder = `INBOUND/${this.savePhotoInfo.parentSeqNo}`;
                   this.savePhotoInfo.image.fileName = "-wtScan.jpg";
                   const regex = /image[/](jpeg|png|gif)/i;
                   var canvas = document.getElementById("photoTaken").toDataURL("image/jpeg")
                       .replace(regex, "image/octet-stream");
                   if (this.isScanImg)
                   {
                      console.log("get testImg");
                      canvas = document.getElementById("testImg").src
                        .replace(regex, "image/octet-stream");
                   }     
                   console.log("img: " + canvas);  
                   var img = canvas.replace("data:image/octet-stream;base64,","");
                   console.log("base64 img: " + img);  

                   this.savePhotoInfo.image.imageBase64 = img;

                  
                   console.log("image folder: " + this.savePhotoInfo.image.folder);
                   console.log("Saving photo...");
                   //api.post('/api/w/ccic/photo/save', this.savePhotoInfo)
                   newAPIPost('/api/w/ccic/photo/save', this.savePhotoInfo)
                     .then( (it) => {
                      console.log("done with image saving");
                      console.log("set getPhotoRequest");
                      //this.onScan(this.dataForm.scanWt, true, this.selectedItem[0].inboundShipment);
                      if (document.getElementById("pb"))
                      {
                         document.getElementById("pb").style.display = "none";
                      }
                      if (document.getElementById("pb1"))
                      {
                         document.getElementById("pb1").style.display = "";
                      }

                      //this.cancelAction();
                      this.hasError = false;
                      this.cancalAction();
                   }
                   ) 

               }

    },

    cancelAction() {
       this.isCameraOpen = false;
       this.isPhotoTaken = false;
       this.isShotPhoto = false;
       this.dataForm.scanWt = "";
       this.stopCameraStream(); 
    },

    toggleItemPhoto() {
        this.$refs.BolPhotoZoomForm.openDialog(
        //this.$refs.BolPhotoForm.openDialog(
          `Photo.zip`,
          this.photoItem.apptNo,
          "BWT",
          photoMetaLoading,
          { seqNo: this.photoItem.apptNo,sortKey : 'BWT' },
          this.photoItem.inboundStatus == 'R' ? false : true,
          this.dataForm.scanWt
        );
    },

    updatePhoto(url, seq){
      // const item = _(this.items)
      //     .find(it => it.apptNo === seq);
      //item.bolScan = url;
      console.log("url: " + url);
    },

    urlExists(url) {
      console.log("wt url: " + url);
      fetch(url)
      .then( (response) => {
        if (response.statusText === "OK")
        {
           console.log("url existed");
           this.hasPhoto = true;
           return true;
        }
        else
        {
           console.log("url not found");
           this.hasPhoto = false;
           return false;
        }

      }
      )
    },

    setError(msg)
    {
        if (document.getElementById("err"))
        {
           document.getElementById("err").textContent = msg;
        }
    },

    getPicURL()
    {
        var appURL = location.href.toUpperCase();
        //var appURL = "http://named-account-web-qas.s3-website-us-west-2.amazonaws.com/#/fsiOperationCockpit/inbound";
        //appURL = appURL.toUpperCase();
        console.log("appURL: " + appURL);
        var env = "dev";
        var picURL = "https://named-account-web-";
        if (appURL != null && appURL != "")
        {
           if (appURL.indexOf("DEV") > 0)
              env = "dev";
           if (appURL.indexOf("QAS") > 0)
              env = "qas";
           if (appURL.indexOf("PRD") > 0)
              env = "prd";
           if (appURL.indexOf("LOCALHOST") > 0)
              env = "dev";
        }
        else
          env = "";
        //picURL.concat(env, ".s3.us-west-2.amazonaws.com/upload_images/INBOUND/");
        picURL += env;
        picURL += ".s3.us-west-2.amazonaws.com/upload_images/INBOUND/";
        console.log("get wt pic url: " + picURL);
        return picURL;
    },

  },
};
</script>
